import { useState } from 'react';
import { useParams } from 'react-router';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { Box, Button, Grid, MenuItem, Stack, TextField } from '@mui/material';

import { useGetLocalitiesQuery } from '@/services';
import { AppBar, Empty, Error, Loader } from '@/components';
import { OrderDirections, ORDER_DIRECTIONS } from '@/utils/order-directions';

import { LocalitiesTable, CreateLocality } from './components';

const LocalitiesPage: React.FC = () => {
  const { districtId } = useParams<{ districtId: string }>();

  const [{ order_direction, page }, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    order_direction: withDefault(StringParam, OrderDirections.DESC),
  });

  const [createModalOpened, setOpenedCreateModal] = useState(false);

  const {
    data: localities,
    isLoading,
    isSuccess,
    isError,
  } = useGetLocalitiesQuery({ params: { order_direction, page, order_by: 'id', parent_id: districtId } });

  return (
    <>
      <AppBar title="Населенные пункты" />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
            <Box sx={{ width: 310 }}>
              <TextField
                select
                value={order_direction}
                label="Сортировать по"
                disabled={isLoading}
                onChange={(event) => setQuery({ order_direction: event.target.value })}
                variant="filled"
                fullWidth
                size="small"
              >
                {ORDER_DIRECTIONS.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box sx={{ width: 210 }}>
              <Button
                disabled={isLoading}
                onClick={() => setOpenedCreateModal(true)}
                size="large"
                variant="contained"
                fullWidth
              >
                Добавить
              </Button>
            </Box>
          </Stack>
        </Grid>

        <Grid item lg={6} xs={12}>
          {isLoading ? (
            <Loader />
          ) : isError ? (
            <Error text="Произошла ошибка с загрузкой населенных пунктов! Пожалуйста, попробуйте позже" />
          ) : isSuccess && Boolean(localities?.data?.length) ? (
            <LocalitiesTable list={localities} page={page} onChangePage={(page) => setQuery({ page })} />
          ) : (
            <Empty text="Населенные пункты отсутствуют" />
          )}
        </Grid>
      </Grid>

      <CreateLocality onClose={() => setOpenedCreateModal(false)} open={createModalOpened} />
    </>
  );
};

export default LocalitiesPage;
